export enum MatchTickerType {
  Live = 'live', // The match is fully tickered by a single user that has explicitly signed up for the ticker
  Soft = 'soft', // Only main events, e.g., goals, might be tickered by multiple users without explicitly signing up for the ticker
}
